import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appProfileImage]',
})
export class CheckImageDirective implements OnChanges {
  @Input() src: string | null;
  private anonymousPhoto = '/assets/images/acc-no-photo.svg';

  constructor(private renderer2: Renderer2, private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.src?.length) {
      this.renderer2.setAttribute(this.elementRef.nativeElement, 'src', this.src);
      return;
    }
    this.renderer2.setAttribute(this.elementRef.nativeElement, 'src', this.anonymousPhoto);
  }
}
